import { render, staticRenderFns } from "./InfocardOrdersListModal.vue?vue&type=template&id=9beb8844&scoped=true&"
import script from "./InfocardOrdersListModal.vue?vue&type=script&lang=js&"
export * from "./InfocardOrdersListModal.vue?vue&type=script&lang=js&"
import style0 from "./InfocardOrdersListModal.vue?vue&type=style&index=0&id=9beb8844&lang=scss&scoped=true&"
import style1 from "./InfocardOrdersListModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9beb8844",
  null
  
)

export default component.exports